// Define swiperScript globally
let swiperScript = null;
let gsapScript = null;
let isSwiperScriptLoaded = false;
let isGsapScriptLoaded = false;
let loadCallbacks = []; // Queue to store callbacks until the script is loaded

// Function to load Swiper.js script dynamically
function loadSwiperScript(callback) {
    if (isSwiperScriptLoaded) {
        // console.log('Swiper.js is already loaded.');
        if (callback) callback(); // Execute callback immediately if already loaded
        return;
    }

    // If a callback is provided, add it to the queue
    if (callback) loadCallbacks.push(callback);

    // Create the script element only if not already created
    if (!swiperScript) {
        swiperScript = document.createElement('script');
        swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js?v=' + Date.now();
        swiperScript.async = true; // Ensure non-blocking loading

        swiperScript.addEventListener('load', () => {
            // console.log('Swiper.js script loaded successfully.');
            isSwiperScriptLoaded = true; // Mark as loaded

            // Execute all queued callbacks
            loadCallbacks.forEach(cb => cb());
            loadCallbacks = []; // Clear the queue
        });

        swiperScript.addEventListener('error', (e) => {
            console.error('Failed to load Swiper.js script:', e);
            // Clear the queue in case of an error to prevent hanging callbacks
            loadCallbacks = [];
        });

        // Append the script to the head
        document.head.appendChild(swiperScript);
    }
}

// function loadGsapScript(callback) {
//     if (isGsapScriptLoaded) {
//         // console.log('Swiper.js is already loaded.');
//         if (callback) callback(); // Execute callback immediately if already loaded
//         return;
//     }

//     // If a callback is provided, add it to the queue
//     if (callback) loadCallbacks.push(callback);

//     // Create the script element only if not already created
//     if (!gsapScript) {
//         gsapScript = document.createElement('script');
//         gsapScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js?v=' + Date.now();
//         gsapScript.async = true; // Ensure non-blocking loading

//         gsapScript.addEventListener('load', () => {
//             // console.log('Swiper.js script loaded successfully.');
//             isGsapScriptLoaded = true; // Mark as loaded

//             // Execute all queued callbacks
//             loadCallbacks.forEach(cb => cb());
//             loadCallbacks = []; // Clear the queue
//         });

//         gsapScript.addEventListener('error', (e) => {
//             console.error('Failed to load gsap.js script:', e);
//             // Clear the queue in case of an error to prevent hanging callbacks
//             loadCallbacks = [];
//         });

//         // Append the script to the head
//         document.head.appendChild(gsapScript);
//     }
// }

// Define hlsScript globally
let hlsScript = null;
let isHlsScriptLoaded = false;
let hlsLoadCallbacks = []; // Queue to store callbacks until the script is loaded

// Function to load HLS.js script dynamically
function loadHlsScript(callback) {
    if (isHlsScriptLoaded) {
        // console.log('HLS.js is already loaded.');
        if (callback) callback(); // Execute callback immediately if already loaded
        return;
    }

    // If a callback is provided, add it to the queue
    if (callback) hlsLoadCallbacks.push(callback);

    // Create the script element only if not already created
    if (!hlsScript) {
        hlsScript = document.createElement('script');
        hlsScript.src = 'https://shopkshm.com/cdn/shop/t/10/assets/hls.min.js?v=173209411494504496521732343855';
        hlsScript.async = true; // Ensure non-blocking loading

        hlsScript.addEventListener('load', () => {
            // console.log('HLS.js script loaded successfully.');
            isHlsScriptLoaded = true; // Mark as loaded

            // Execute all queued callbacks
            hlsLoadCallbacks.forEach(cb => cb());
            hlsLoadCallbacks = []; // Clear the queue
        });

        hlsScript.addEventListener('error', (e) => {
            console.error('Failed to load HLS.js script:', e);
            // Clear the queue in case of an error to prevent hanging callbacks
            hlsLoadCallbacks = [];
        });

        // Append the script to the head
        document.head.appendChild(hlsScript);
    }
}